import React from 'react';
import { Trans } from 'react-i18next';

import { Button } from '@actual-app/components/button';
import { Text } from '@actual-app/components/text';
import { theme } from '@actual-app/components/theme';
import { View } from '@actual-app/components/view';

import type { TransferMatchItem } from '#banksync/transfer-match';
import { FinancialText } from '#components/FinancialText';
import { useFormat } from '#hooks/useFormat';

type Props = {
  item: TransferMatchItem;
  onAccept: () => void;
  onDismiss: () => void;
};

export function TransferMatchRow({ item, onAccept, onDismiss }: Props) {
  const format = useFormat();
  const sameDate = item.from.date === item.to.date;
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        padding: 8,
        borderBottom: '1px solid ' + theme.tableBorder,
        flexShrink: 0,
      }}
    >
      <View style={{ flex: 1, minWidth: 0 }}>
        <Text style={{ fontSize: 13, fontWeight: 500 }}>
          {item.fromAccountName} {'->'} {item.toAccountName}
        </Text>
        <Text style={{ fontSize: 12, color: theme.pageTextSubdued }}>
          <FinancialText>{format(item.from.amount, 'financial')}</FinancialText>
          {'  '}
          {item.from.date}
          {sameDate ? '' : ' / ' + item.to.date}
        </Text>
      </View>
      <Button onPress={onDismiss}>
        <Trans>Dismiss</Trans>
      </Button>
      <Button variant="primary" onPress={onAccept}>
        <Trans>Make transfer</Trans>
      </Button>
    </View>
  );
}
